import axiosInstance from "./axiosInstance";

export const sendQuotationRequest = async (data) => {
  try {
    const response = await axiosInstance.post(
      "/api/v1/wms/users/quotation-request",
      data
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Something went wrong";
  }
};